// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__13elJ","detailsBorder":"styles_detailsBorder__P2odh"};